import { render } from "./TenantUserEditUserGroupDialog.vue?vue&type=template&id=5c94470e"
import script from "./TenantUserEditUserGroupDialog.vue?vue&type=script&lang=js"
export * from "./TenantUserEditUserGroupDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__